module.exports = __webpack_public_path__ + "media/images/hapier/conceito_hapier_1-d955ee4f8a4f1341ccd084e6998e98cb.png";